import {Dispatch, SetStateAction} from 'react'
import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
  RequestResult,
} from '../../lib'

import {doREQUEST_ERROR, doREQUEST_COMPLETE} from '../state'
import {getToken} from './token_fetcher'

export const REQUEST_PROJECT_REALTIME_DATA_FETCH = 'REQUEST_PROJECT_REALTIME_DATA_FETCH'
export const doREQUEST_PROJECT_REALTIME_DATA_FETCH = createDoRequestAction(REQUEST_PROJECT_REALTIME_DATA_FETCH)

export const requestProjectRealtimeDataFetchActionCreators = {
  doREQUEST_PROJECT_REALTIME_DATA_FETCH,
}

interface RequestProjectRealtimeDataFetchPayload {
  payload: {
    requestId: string
    projectId: string
    bufferTime: number
  }
  type: string
  setRequestResult?: Dispatch<SetStateAction<RequestResult | null>>
}

export function* requestProjectRealtimeDataFetch({
  payload,
  setRequestResult,
}: RequestProjectRealtimeDataFetchPayload): SagaIterator {
  debug('saga*requestProjectRealtimeDataFetch')
  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        projectId: v.string().uuid().exist(),
        requestId: v.string().uuid().exist(),
        bufferTime: v.number().exist(),
      }),
    })
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_REALTIME_DATA_FETCH,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const {projectId, bufferTime} = payload

  const accessToken = yield call(getToken)
  const result = yield request({
    method: 'post',
    url: `${API_URL}/v1/web/project-realtime-data-fetch`,
    // url: `${API_URL}/v1/common/realtime-data-fetch`,
    accessToken,
    data: {
      // secret: '0010e378-1950-48b6-993a-5480cb05ed92',
      projectId,
      bufferTime,
    },
  })
  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_REALTIME_DATA_FETCH,
          fromPayload: payload,
          requestId: payload.requestId,
          url: '/v1/web/project-realtime-data-fetch',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_PROJECT_REALTIME_DATA_FETCH,
        fromPayload: payload,
        requestId: payload.requestId,
        url: '/v1/web/project-realtime-data-fetch',
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* projectRealtimeDataFetchSaga() {
  yield takeEvery(REQUEST_PROJECT_REALTIME_DATA_FETCH, requestProjectRealtimeDataFetch)
}
